export default {
  LOW: 'low',
  HIGH: 'high',
  CRITICAL: 'critical',
};
